import React from 'react'
import {FaExclamationCircle} from 'react-icons/fa'
import getUserFriendlyErrorInfo from '@helpers/misc/getUserFriendlyErrorInfo'

import styles from './styles.module.css'
export default function ErrorBox({
  message,
  style,
  error
}: {
  message: string
  style?: any
  error?: any
}) {
  if (error) {
    const {message: friendlyMessage, errorInfo} = getUserFriendlyErrorInfo(error)
    return (
      <div className={styles.container}>
        <div className={styles.inner} style={style}>
          <FaExclamationCircle size={15} className={styles.icon} />
          Ocurrió un error. {friendlyMessage}{' '}
          {errorInfo.length > 0 ? `: ${errorInfo.join(', ')}` : ''}
        </div>
      </div>
    )
  }
  return (
    <>
      {!message ? null : (
        <div className={styles.container}>
          <div className={styles.inner} style={style}>
            <FaExclamationCircle size={15} className={styles.icon} />
            {message}
          </div>
        </div>
      )}
    </>
  )
}
